import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import { BRIDGE_URL } from "../utils/constants"


// Fetch all stores in DB
export const getAllStores = async () => {

    try {

        const token = localStorage.getItem("oss-token")
        if (!token) {
            token = await fetchAccessToken();  // Wait for the token to be fetched before proceeding
            if (!token) {
                throw new Error("Unable to fetch token");
            }
            localStorage.setItem("oss-token", token);  // Store the token in localStorage if newly fetched
        }


        const headers = {
            "Authorization": `Bearer ${token}`
        }

        const res = await axios.get(`${BRIDGE_URL("services/apexrest/store/?locationId=asds")}`, { headers })
        if(res?.data?.length === 0) return []
        return res.data

    } catch (err) {
        console.log(err)
        return [];
    }

}
